//actions sur les messages
export const PENDING_STORE = 'PENDING_STORE'
export const SUCCESS_STORE = 'SUCCESS_STORE'
export const FAIL_STORE = 'FAIL_STORE'
export const PENDING_REGIONS = 'PENDING_REGIONS'
export const SUCCESS_REGIONS = 'SUCCESS_REGIONS'
export const FAIL_REGIONS = 'FAIL_REGIONS'
export const PENDING_DEPARTEMENTS = 'PENDING_DEPARTEMENTS'
export const SUCCESS_DEPARTEMENTS = 'SUCCESS_DEPARTEMENTS'
export const FAIL_DEPARTEMENTS = 'FAIL_DEPARTEMENTS'
export const PENDING_ARRONDISSEMENTS = 'PENDING_ARRONDISSEMENTS'
export const SUCCESS_ARRONDISSEMENTS = 'SUCCESS_ARRONDISSEMENTS'
export const FAIL_ARRONDISSEMENTS = 'FAIL_ARRONDISSEMENTS'
export const PENDING_ETABLISSEMENTS = 'PENDING_ETABLISSEMENTS'
export const PENDING_ETABLISSEMENTS_ITEM = 'PENDING_ETABLISSEMENTS_ITEM'
export const SUCCESS_ETABLISSEMENTS = 'SUCCESS_ETABLISSEMENTS'
export const FAIL_ETABLISSEMENTS = 'FAIL_ETABLISSEMENTS'
export const SUCCESS_ETABLISSEMENTS_ITEM = 'SUCCESS_ETABLISSEMENTS_ITEM'
export const FAIL_ETABLISSEMENTS_ITEM = 'FAIL_ETABLISSEMENTS_ITEM'
export const PENDING_ETABLISSEMENTS_SEARCH = 'PENDING_ETABLISSEMENTS_SEARCH'
export const SUCCESS_ETABLISSEMENTS_SEARCH = 'SUCCESS_ETABLISSEMENTS_SEARCH'
export const FAIL_ETABLISSEMENTS_SEARCH = 'FAIL_ETABLISSEMENTS_SEARCH'
export const PENDING_FRAIS_ITEM = 'PENDING_FRAIS_ITEM'
export const SUCCESS_FRAIS_ITEM = 'SUCCESS_FRAIS_ITEM'
export const FAIL_FRAIS_ITEM = 'FAIL_FRAIS_ITEM'

export const SET_MENUHEADER = "SET_MENUHEADER";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const SET = "set";

export const GET_REGISTRATION_REFERENCE = "GET_REGISTRATION_REFERENCE";
export const GET_REGISTRATION_REFERENCE_BILL = "GET_REGISTRATION_REFERENCE_BILL";
export const GET_REGISTRATION_REFERENCE_FAIL = "GET_REGISTRATION_REFERENCE_FAIL";
export const GET_REGISTRATION_INITPAY = "GET_REGISTRATION_INITPAY";

export const GET_REGIONS_SUCCESS = "GET_REGIONS_SUCCESS";
export const GET_REGIONS_FAIL = "GET_REGIONS_FAIL";
export const GET_REGIONS_DEPARTEMENTS_SUCCESS = "GET_REGIONS_DEPARTEMENTS_SUCCESS";
export const GET_REGIONS_DEPARTEMENTS_FAIL = "GET_REGIONS_DEPARTEMENTS_FAIL";

export const GET_DEPARTEMENTS_SUCCESS = "GET_DEPARTEMENTS_SUCCESS";
export const GET_DEPARTEMENTS_FAIL = "GET_DEPARTEMENTS_FAIL";
export const GET_DEPARTEMENTS_ARRONDISSEMENTS_SUCCESS = "GET_DEPARTEMENTS_ARRONDISSEMENTS_SUCCESS";
export const GET_DEPARTEMENTS_ARRONDISSEMENTS_FAIL = "GET_DEPARTEMENTS_ARRONDISSEMENTS_FAIL";

export const GET_ARRONDISSEMENTS_ETABLISSEMENTS_SUCCESS = "GET_ARRONDISSEMENTS_ETABLISSEMENTS_SUCCESS";
export const GET_ARRONDISSEMENTS_ETABLISSEMENTS_FAIL = "GET_ARRONDISSEMENTS_ETABLISSEMENTS_FAIL";

export const GET_ETABLISSEMENTS_CLASSES_SUCCESS = "GET_ETABLISSEMENTS_CLASSES_SUCCESS";
export const GET_ETABLISSEMENTS_CLASSES_FAIL = "GET_ETABLISSEMENTS_CLASSES_FAIL";
export const GET_ETABLISSEMENTS_EXAMENS_SUCCESS = "GET_ETABLISSEMENTS_EXAMENS_SUCCESS";
export const GET_ETABLISSEMENTS_EXAMENS_FAIL = "GET_ETABLISSEMENTS_EXAMENS_FAIL";
export const GET_ETABLISSEMENTS_ITEM_SUCCESS = "GET_ETABLISSEMENTS_ITEM_SUCCESS";
export const GET_ETABLISSEMENTS_ITEM_FAIL = "GET_ETABLISSEMENTS_ITEM_FAIL";
export const GET_ETABLISSEMENTS_SEARCH_SUCCESS = "GET_ETABLISSEMENTS_SEARCH_SUCCESS";
export const GET_ETABLISSEMENTS_SEARCH_FAIL = "GET_ETABLISSEMENTS_SEARCH_FAIL";

export const GET_FRAIS_ITEM_SUCCESS = "GET_FRAIS_ITEM_SUCCESS";
export const GET_FRAIS_ITEM_FAIL = "GET_FRAIS_ITEM_FAIL";
